module.exports = __webpack_public_path__ + "bda0ee630a0958b39529edeac85a06b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/report/senior_report/assets/其它@2x.png
// module id = 802
// module chunks = 0